<template>
  <div>
    <el-cascader
      :style="styles"
      :size="size"
      :placeholder="placeholder"
      :options="options"
      clearable
      ref="cascader"
      :props="{
        checkStrictly: checkedNode,
        label: 'name',
        value: 'adcode',
        emitPath,
        multiple,
        expandTrigger
      }"
      v-model="val"
      filterable
      @change="handlerChange"
    />
  </div>
</template>

<script>
  import { getDistinct } from '@/api/public'
  export default {
    name: 'ComCityLevelSelector',
    props: {
      value: {
        type: [String, Number, Array],
        required: true
      },
      level: {
        type: String,
        default: () => 'district' // 默认显示省、市、区三级
      },
      size: {
        type: String,
        default: () => ''
      },
      // 是否多选
      multiple: {
        type: Boolean,
        default: false
      },
      placeholder: {
        type: String,
        default: '请选择省/市/区'
      },
      styles: {
        type: Object,
        default: () => {}
      },
      // 需要展示的省，为数组，数组中的是需要展示的。
      showProvince: {
        type: Array,
        default: () => ['云南省', '四川省', '贵州省', '湖南省', '黑龙江省']
      },
      // 是否可选任意一级还是末级
      checkedNode: {
        type: Boolean,
        default: true
      },
      emitPath: {
        type: Boolean,
        default: false
      },
      expandTrigger: {
        type: String,
        default: () => 'hover'
      }
    },
    data() {
      return {
        val: undefined,
        options: []
      }
    },
    watch: {
      val: {
        handler(newVal, oldVal) {
          if (newVal === oldVal) {
            return
          }
          this.emitInput()
        }
      },
      value: {
        handler(newVal, oldVal) {
          if (newVal === this.val) {
            return
          }
          if (newVal && Array.isArray(newVal)) {
            this.val = newVal
            return
          }
          if (!newVal) {
            this.val = undefined
            return
          }
          this.val = +newVal
        },
        immediate: true
      },
      'showProvince.length': {
        handler() {
          this.getList()
        },
        immediate: true
      }
    },
    mounted() {
      this.getList()
    },
    methods: {
      async getList() {
        const { children } = await getDistinct()
        if (!Array.isArray(children)) {
          return
        }
        let opt = []
        if (this.showProvince.length) {
          this.showProvince.forEach((it) => {
            children.forEach((v) => {
              if (it === v.name) {
                opt.push(v)
              }
            })
          })
        } else {
          opt = children
        }
        if (this.level === 'city') {
          opt = opt.map((item) => {
            if (item.children && item.children.length > 0) {
              item.children = item.children
                .filter((obj) => obj.level === 'city')
                .map((obj) => {
                  delete obj.children
                  return obj
                })
            }
            return item
          })
        }
        this.options = opt
      },
      emitInput() {
        this.$emit('input', this.val)
      },
      handlerChange(id) {
        if (this.multiple) {
          this.$emit('change', id)
          return
        }
        this.$refs.cascader.dropDownVisible = false
        // const item = this.$refs.cascader.getCheckedNodes()[0]
        const item = this.$refs.cascader.panel.getNodeByValue(id) || {}
        this.$emit('change', item)
      }
    }
  }
</script>

<style lang="scss" scoped></style>
